import { z } from 'zod'
import { UserRole } from '@/core/domain/resources/enums/UserRole.ts'

/**
 * Représente l'ensemble des rôles d'un utilisateur nécessitant au moins un élément.
 */
export const UserListRolesSchema = z.array(z.nativeEnum(UserRole.Values))
  .refine((value) => value.length > 0 && new Set(value).size === value.length, 'Au moins un rôle est requis')

export type UserListRolesEntity = z.infer<typeof UserListRolesSchema>